import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { createContactNavigationHandler } from '../../../utils/contactNavigation';
import {
  FooterContainer,
  FooterContent,
  FooterSection,
  CopyrightText,
  SocialLinksContainer,
  SocialLink,
  AimScoreContainer,
  AimScoreText,
  AimScoreLink,
} from './Footer.styles';
import { aimScores, AIM_SCORE_DESCRIPTION } from './aimScores';

function Footer() {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;
  const currentAimScore = aimScores[currentPath] || aimScores['/'];
  const currentYear = new Date().getFullYear();
  const handleContactClick = createContactNavigationHandler(navigate);

  return (
    <FooterContainer role="contentinfo" aria-label="Site footer">
      <FooterContent>
        <FooterSection>
          <CopyrightText variant="caption" component="p">
            © {currentYear} Hadley Swello. All rights reserved.
          </CopyrightText>
        </FooterSection>

        <FooterSection>
          <SocialLinksContainer role="list" aria-label="Social media links">
            <SocialLink
              onClick={handleContactClick}
              aria-label="Email Hadley Swello"
              component="button"
              role="listitem"
            >
              Email
            </SocialLink>
            <SocialLink
              href="https://www.linkedin.com/in/hadleyswello/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Hadley Swello on LinkedIn"
              component="a"
              role="listitem"
            >
              LinkedIn
            </SocialLink>
            <SocialLink
              href="https://github.com/HadleySwello"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Hadley Swello on GitHub"
              component="a"
              role="listitem"
            >
              GitHub
            </SocialLink>
          </SocialLinksContainer>
        </FooterSection>

        <FooterSection>
          <AimScoreContainer>
            {currentAimScore.score !== null ? (
              <>
                <Tooltip title={AIM_SCORE_DESCRIPTION} arrow>
                  <AimScoreText variant="caption" component="p">
                    WAVE Accessibility Impact Score: {currentAimScore.score}/10
                  </AimScoreText>
                </Tooltip>
                <AimScoreLink
                  href="https://wave.webaim.org/aimscore"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Learn more about WAVE AIM Score"
                  component="a"
                >
                  Learn more
                </AimScoreLink>
              </>
            ) : (
              <AimScoreText variant="caption" component="p">
                WAVE Accessibility Impact Score: Pending
              </AimScoreText>
            )}
          </AimScoreContainer>
        </FooterSection>
      </FooterContent>
    </FooterContainer>
  );
}

export default Footer;
